var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-table",
    {
      attrs: { data: _vm.event.history },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(props) {
            return [
              _c(
                "sc-table-column",
                { attrs: { label: "Data", field: "date", width: "90" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("date")(props.row.date, "DD/MM/YYYY HH:mm:ss")
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Status", field: "status", width: "120" } },
                [_vm._v("\n      " + _vm._s(props.row.status) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    label: "Sub Status",
                    field: "substatus",
                    width: "120"
                  }
                },
                [_vm._v("\n      " + _vm._s(props.row.substatus) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    label: "Mensagem",
                    field: "message",
                    centered: false
                  }
                },
                [_c("span", [_vm._v(_vm._s(props.row.message))])]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "template",
        { attrs: { slot: "empty" }, slot: "empty" },
        [_c("sc-table-empty")],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45303601", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45303601","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-detail/tabs/tab-logs-tracking-detail-history/TabLogsTrackingDetailHistory.vue
// module id = null
// module chunks = 